var all = function (arr, fn) {
    if (fn === void 0) { fn = Boolean; }
    return arr.every(function () { return fn(); });
};
var ɵ0 = all;
var any = function (arr, fn) {
    if (fn === void 0) { fn = Boolean; }
    return arr.some(function () { return fn(); });
};
var ɵ1 = any;
var doAllApi = function (fn) { return function () {
    var params = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        params[_i] = arguments[_i];
    }
    return all(params, fn);
}; };
var ɵ2 = doAllApi;
var doAnyApi = function (fn) { return function () {
    var params = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        params[_i] = arguments[_i];
    }
    return any(params, fn);
}; };
var ɵ3 = doAnyApi;
var types = [
    "Map",
    "Set",
    "Symbol",
    "Array",
    "Object",
    "String",
    "Date",
    "RegExp",
    "Function",
    "Boolean",
    "Number",
    "Null",
    "Undefined",
    "Arguments",
    "Error",
    "Request",
    "Response",
    "Headers",
    "Blob"
];
var len = types.length;
var typeCache = {};
var typeRegexp = /\s([a-zA-Z]+)/;
function getSrcType(src) {
    // When Angular Elements with zone.js is present, the standard check for undefined and null returns "window"
    // Due to that issue we are doing this special check for undefined and null
    if (typeof src === "undefined") {
        return "undefined";
    }
    if (src === null) {
        return "null";
    }
    var type = Object.prototype.toString.call(src);
    if (!typeCache[type]) {
        var matches = type.match(typeRegexp);
        if (Array.isArray(matches) && matches.length > 1) {
            typeCache[type] = matches[1].toLowerCase();
        }
    }
    return typeCache[type];
}
function setup() {
    var checks = {};
    var _loop_1 = function (i) {
        var type = types[i].toLowerCase();
        checks[type] = function (src) { return getSrcType(src) === type; };
        checks[type].all = doAllApi(checks[type]);
        checks[type].any = doAnyApi(checks[type]);
    };
    for (var i = len; i--;) {
        _loop_1(i);
    }
    return checks;
}
var is = setup();
var getType = function (src) { return getSrcType(src); };
var ɵ4 = getType;
function isPrimitive(src) {
    return is.boolean(src) || is.number(src) || is.string(src);
}
function isValidObject(candidate) {
    var isValid = false;
    if (is.undefined(candidate) ||
        is.null(candidate) ||
        is.object(candidate) ||
        is.array(candidate) ||
        isPrimitive(candidate)) {
        isValid = true;
        if (is.object(candidate) || is.array(candidate)) {
            var props = Object.keys(candidate);
            for (var i = 0; i < props.length; i++) {
                if (!isValidObject(candidate[props[i]])) {
                    isValid = false;
                    break;
                }
            }
        }
    }
    return isValid;
}
export { is, isPrimitive, isValidObject, getType };
export { ɵ0, ɵ1, ɵ2, ɵ3, ɵ4 };
//# sourceMappingURL=is-type.js.map